import Vue from 'vue'
import './cube-ui'
import App from './App.vue'
import router from './router'
import store from './store'

import customAxios from './utils/custom_axios'
import './utils/refresh_token'
import './assets/css/global.css'
import './assets/iconfont/iconfont.js'
import gf from './utils/global_function'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import VueAMap from 'vue-amap'
Vue.use(VueAMap)

Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.use(gf)
Vue.prototype.$axios = customAxios

const app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
// .$mount('#app')

if ((!navigator.userAgent.match(/(test|MicroMessenger|phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
  // 判断浏览器类型进行提醒
  const regChrome = /chrome\/[\d.]+/gi
  // let regFirefox = /firefox\/[\d.]+/gi;

  const userAgent = navigator.userAgent

  if (userAgent.indexOf('Chrome') !== -1) {
    if (parseInt(userAgent.match(regChrome).toString().split('/')[1]) < 63) {
      browserNotify('为了更好的使用体验，推荐升级Chrome浏览器到最新版本')
    }
  } else {
    browserNotify('为了更好的使用体验，推荐使用最新版Chrome浏览器')
  }
}

function browserNotify (msg) {
  app.$notify({
    title: '重要提醒',
    message: msg,
    type: 'warning',
    duration: 0
  })
}
